<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet class="mx-3 mt-5" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
          <v-row class="mx-3">
            <v-col>
              <CommonFieldString
                  v-model="currentItem.name"
                  label="CasePackage"
                  counter
                  maxlength="20"
              ></CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldSelect
                  v-if="!!storeDetail.common.data && !!currentItem"
                  v-model="currentItem.case_package_type"
                  :items="storeDetail.common.data.case_package_component_type_items"
                  item-text="text"
                  item-value="value"
                  label="Type"
                  :clearable="true"
              >
              </CommonFieldSelect>
            </v-col>
            <v-col>
              <v-checkbox
                  v-model="currentItem.need_common"
                  label="Need common"
                  class="mt-1"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                  v-model="currentItem.need_resistor"
                  label="Need resistor"
                  class="mt-1"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox
                  v-model="currentItem.need_capacitor"
                  label="Need capacitor"
                  class="mt-1"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-tabs v-if="!!currentItem.default_supply_information">
            <v-tab :disabled="!need_common">
              Common
              <v-tooltip
                  v-if="!currentItem.teach_complete_common"
                  bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="error" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                </template>
                <span>The teach is not completed</span>
              </v-tooltip>
              <v-icon
                  v-if="currentItem.teach_complete_common"
                  small color="success">mdi-check-circle-outline
              </v-icon>
            </v-tab>
            <v-tab-item>
              <CoreCasePackageSupplyDefault
                  v-model="currentItem.default_supply_information.common"
                  subdivision="common"
                  @input="onChangeDefaultSupplyInformation()"
                  :height="height - 210"
              ></CoreCasePackageSupplyDefault>
            </v-tab-item>
            <v-tab :disabled="!need_resistor">
              Resistor
              <v-tooltip
                  v-if="!currentItem.teach_complete_resistor"
                  bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="error" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                </template>
                <span>The teach is not completed</span>
              </v-tooltip>
              <v-icon
                  v-if="!currentItem.teach_complete_resistor"
                  small color="success">mdi-check-circle-outline
              </v-icon>
            </v-tab>
            <v-tab-item>
              <CoreCasePackageSupplyDefault
                  v-model="currentItem.default_supply_information.resistor"
                  :height="height - 210"
                  @input="onChangeDefaultSupplyInformation()"
              ></CoreCasePackageSupplyDefault>
            </v-tab-item>
            <v-tab :disabled="!need_capacitor">
              Capacitor
              <v-tooltip
                  v-if="!currentItem.teach_complete_capacitor"
                  bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="error" v-bind="attrs" v-on="on">mdi-check-circle-outline</v-icon>
                </template>
                <span>The teach is not completed</span>
              </v-tooltip>
              <v-icon
                  v-if="currentItem.teach_complete_capacitor"
                  small color="success">mdi-check-circle-outline
              </v-icon>
            </v-tab>
            <v-tab-item>
              <CoreCasePackageSupplyDefault
                  v-model="currentItem.default_supply_information.capacitor"
                  :height="height - 210"
                  @input="onChangeDefaultSupplyInformation()"
              ></CoreCasePackageSupplyDefault>
            </v-tab-item>
            <v-tab>XML</v-tab>
            <v-tab-item>
              <v-col>
                <CommonFieldText
                    v-model="currentItem.common_xml"
                    label="Common XML"
                    rows="6"
                    counter
                    clearable=""
                ></CommonFieldText>
              </v-col>
              <v-col>
                <CommonFieldText
                    v-model="currentItem.resistor_xml"
                    label="Resistor XML"
                    rows="6"
                    counter
                    clearable=""
                ></CommonFieldText>
              </v-col>
              <v-col>
                <CommonFieldText
                    v-model="currentItem.capacitor_xml"
                    label="Capacitor XML"
                    rows="6"
                    counter
                    clearable=""
                ></CommonFieldText>
              </v-col>
            </v-tab-item>
            <v-tab>Subcategory</v-tab>
            <v-tab-item>
              <CoreSubcategoryTable
                  title="Subcategory in members"
                  dtoListQuery="SubcategoryMembersInListQueryDTO"
                  :store-name="storeSubcategoryInMembersTableName"
                  :height="height / 2 - 220"
                  @alternate_action="onAlternateAction($event)"
              >
                <template v-slot:top>{{ '' }}</template>
              </CoreSubcategoryTable>
              <!--              :headers="membersHeaders"-->
              <CoreSubcategoryTable
                  title="Subcategory out members"
                  dtoListQuery="SubcategoryMembersOutListQueryDTO"
                  :store-name="storeSubcategoryOutMembersTableName"
                  :height="height / 2 - 160"
                  detail-store-name="CasePackageSubcategoryMembers"
                  @alternate_action="onAlternateAction($event)"
              >
              </CoreSubcategoryTable>
            </v-tab-item>
            <v-tab>Matching</v-tab>
            <v-tab-item>
              <CommonChipCombobox
                  height="300"
                  v-model="currentItem.match_list"
              ></CommonChipCombobox>
            </v-tab-item>
            <v-tab>Articles</v-tab>
            <v-tab-item>
              <ComponentTable
                  :store-name="storeComponentTableName"
                  :height="height - 290"
                  dto-list-query="ComponentMembersCasePackageListQueryDTO"
              >
              </ComponentTable>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldText from "@/components/Common/CommonFieldText";
import CoreCasePackageSupplyDefault from "@/components/CoreComponent/CasePackage/CoreCasePackageSupplyDefault";
import CommonFieldSelect from "@/components/Common/CommonFieldSelect";
import {v4 as uuidv4} from "uuid";
import {useTableStore} from "@/components/Common/CommonTable";
import CommonChipCombobox from "@/components/Common/CommonChipCombobox";

export default {
  name: "CoreSpecAttrDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'CasePackageDetail'},
    dtoDetailQuery: {default: 'CasePackageDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CasePackageActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'CasePackageSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'CasePackageValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'CasePackageDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreCasePackageTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonDetail,
    CommonFieldString,
    CommonFieldText,
    CoreCasePackageSupplyDefault,
    CommonFieldSelect,
    CoreSubcategoryTable: () => import("@/components/CoreComponent/Subcategory/CoreSubcategoryTable"),
    ComponentTable: () => import("@/components/CoreComponent/Component/ComponentTable"),
    CommonChipCombobox,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    need_common() {
      if (!!this.currentItem)
        return this.currentItem.need_common === true
      else
        return false
    },
    need_resistor() {
      if (!!this.currentItem)
        return this.currentItem.need_resistor === true
      else
        return false
    },
    need_capacitor() {
      if (!!this.currentItem)
        return this.currentItem.need_capacitor === true
      else
        return false
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterSubcategory()
        this.filterComponent()
      }
    },
    need_common: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterSubcategory()
      }
    },
    need_resistor: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterSubcategory()
      }
    },
    need_capacitor: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterSubcategory()
      }
    },
  },

  methods: {
    onChangeDefaultSupplyInformation() {
      console.log('onChangeDefaultSupplyInformation')
      this.currentItem.default_supply_information = structuredClone(this.currentItem.default_supply_information)
    },
    filterSubcategory() {
      this.storeSubcategoryInMembersTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'casepackage__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
      this.storeSubcategoryOutMembersTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'casepackage__uid', value: this.storeDetail.uidItem, negative: true},
          {
            and_concat: false,
            filter_list: [
              {param_compare: 'maybe_common', value: true, negative: false, enable: this.need_common},
              {param_compare: 'maybe_resistor', value: true, negative: false, enable: this.need_resistor},
              {param_compare: 'maybe_capacitor', value: true, negative: false, enable: this.need_capacitor},
            ],
          },
        ],
        enable: true,
      }
      this.storeSubcategoryInMembersTable.uidItem = this.storeDetail.uidItem
      this.storeSubcategoryOutMembersTable.uidItem = this.storeDetail.uidItem
    },
    filterComponent() {
      this.storeComponentTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'case_package__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
    onAlternateAction(event) {
      // console.log('onAlternateAction', event)
      if (event.actionName === 'alternate_remove_from_group')
        this.storeSubcategoryInMembersTable.onAction({
          actionName: 'remove_from_group', actionUid: event.actionUid,
          callReceive: this.refreshTables
        })
      if (event.actionName === 'alternate_add_to_group')
        this.storeSubcategoryOutMembersTable.onAction({
          actionName: 'add_to_group', actionUid: event.actionUid,
          callReceive: this.refreshTables
        })
    },
    refreshTables(data) {
      // console.log('refreshTables', data)
      this.storeSubcategoryInMembersTable.update()
      this.storeSubcategoryOutMembersTable.update()
    },
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    this.storeSubcategoryInMembersTable = useTableStore(this.storeSubcategoryInMembersTableName)()
    this.storeSubcategoryOutMembersTable = useTableStore(this.storeSubcategoryOutMembersTableName)()
    this.storeComponentTable = useTableStore(this.storeComponentTableName)()
    this.filterSubcategory()
    this.filterComponent()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeSubcategoryInMembersTable: null,
      storeSubcategoryOutMembersTable: null,
      storeSubcategoryInMembersTableName: uuidv4(),
      storeSubcategoryOutMembersTableName: uuidv4(),
      storeComponentTable: null,
      storeComponentTableName: uuidv4(),
    }
  }
  ,
}
</script>

<style scoped>

</style>